module.exports = __webpack_public_path__ + "img/head.ee1f8683.png";